// src/data/mockData.js

// Mock user data (note: plan is stored as slug for consistency)
export const mockUser = {
  id: 1,
  name: "John Doe",
  email: "john.doe@example.com",
  plan: "pro", // use slug (free, pro, team)
  quotaUsed: 15,
  quotaTotal: 50,
  avatar: "https://ui-avatars.com/api/?name=John+Doe&background=0ea5e9&color=fff"
};

// Mock uploaded papers
export const mockPapers = [
  {
    id: 1,
    title: "Deep Learning for Computer Vision",
    author: "Smith et al.",
    uploadDate: "2025-01-15",
    status: "completed",
    summary: "This paper explores advanced deep learning architectures for computer vision tasks.",
    pdfUrl: "#"
  },
  {
    id: 2,
    title: "Quantum Computing Algorithms",
    author: "Johnson & Lee",
    uploadDate: "2025-01-10",
    status: "completed",
    summary: "An overview of quantum algorithms and their potential applications.",
    pdfUrl: "#"
  },
  {
    id: 3,
    title: "Natural Language Processing with Transformers",
    author: "Chen et al.",
    uploadDate: "2025-01-08",
    status: "processing",
    summary: "In progress...",
    pdfUrl: "#"
  },
  {
    id: 4,
    title: "Blockchain Technology in Healthcare",
    author: "Williams & Brown",
    uploadDate: "2025-01-05",
    status: "failed",
    summary: "Error processing document.",
    pdfUrl: "#"
  }
];

// Mock paper result with full details
export const mockPaperResult = {
  id: 1,
  title: "Deep Learning for Computer Vision",
  author: "Smith et al.",
  summary: "This comprehensive paper explores state-of-the-art deep learning architectures specifically designed for computer vision tasks...",
  keyFindings: [
    "Novel attention mechanism improves accuracy by 12%",
    "Reduced computational cost by 30% compared to baseline",
    "Achieves state-of-the-art results on ImageNet dataset",
    "Successfully transfers to other vision tasks"
  ],
  methodology: "The research employs a hybrid architecture combining convolutional layers with self-attention mechanisms. Experiments were conducted on multiple datasets including ImageNet, COCO, and Pascal VOC.",
  architecture: `graph TD
    A[Input Image] --> B[Convolutional Layers]
    B --> C[Attention Module]
    C --> D[Feature Extraction]
    D --> E[Classification Head]
    E --> F[Output Predictions]
    
    style A fill:#e1f5ff
    style F fill:#d4edda`,
  code: `import torch
import torch.nn as nn

class AttentionCNN(nn.Module):
    ...`,
  references: [
    "Smith, J., et al. (2024). 'Advanced Attention Mechanisms for Vision'",
    "Vaswani, A., et al. (2017). 'Attention Is All You Need'",
    "He, K., et al. (2016). 'Deep Residual Learning for Image Recognition'"
  ]
};

// Mock pricing plans (enhanced for front-end & Stripe)
export const pricingPlans = [
  {
    id: 1,
    slug: "free",
    name: "Free",
    price: "$0",
    amountCents: 0,
    currency: "usd",
    billingInterval: "forever",
    period: "forever",
    quota: 5, // numeric papers per month
    features: [
      "5 papers per month",
      "Basic summaries",
      "PDF export",
      "Community support"
    ],
    buttonText: "Current Plan",
    popular: false,
    priceId: null // no stripe price for free
  },
  {
    id: 2,
    slug: "pro",
    name: "Pro",
    price: "$19",
    amountCents: 1900,
    currency: "usd",
    billingInterval: "month",
    period: "per month",
    quota: 50,
    features: [
      "50 papers per month",
      "Advanced summaries",
      "Code generation",
      "Architecture diagrams",
      "Priority support",
      "Export to CodeSandbox"
    ],
    buttonText: "Upgrade to Pro",
    popular: true,
    // Replace with your real Stripe Price ID later:
    priceId: "price_1ProPlaceholder_xxx"
  },
  {
    id: 3,
    slug: "team",
    name: "Team",
    price: "$99",
    amountCents: 9900,
    currency: "usd",
    billingInterval: "month",
    period: "per month",
    quota: -1, // -1 => unlimited
    features: [
      "Unlimited papers",
      "Custom AI models",
      "API access",
      "Team collaboration",
      "Dedicated support",
      "Custom integrations"
    ],
    buttonText: "Contact Sales",
    popular: false,
    priceId: "price_1TeamPlaceholder_xxx"
  }
];

// Mock admin metrics
export const mockAdminMetrics = {
  totalUsers: 1247,
  activeUsers: 892,
  totalPapers: 5683,
  successRate: 94.2,
  monthlyGrowth: [
    { month: 'Jul', users: 450, papers: 1200 },
    { month: 'Aug', users: 580, papers: 1850 },
    { month: 'Sep', users: 720, papers: 2400 },
    { month: 'Oct', users: 890, papers: 3200 },
    { month: 'Nov', users: 1100, papers: 4500 },
    { month: 'Dec', users: 1247, papers: 5683 }
  ],
  planDistribution: [
    { name: 'Free', value: 65 },
    { name: 'Pro', value: 28 },
    { name: 'Team', value: 7 }
  ]
};